import axios from 'axios';

const useMedia = () => {
  const token = localStorage.getItem('authToken');
  const url = window.__pixelConfig.APP_MEDIA_SERVER;

  const getImageById = (id, type = 'download') => {
    return `${url}/${type}/${id}/${token}`;
  };

  const uploadMedia = (file, progress = 0, id = '0', fileName) => {
    const formData = new FormData();
    if (file) {
      formData.append('uploaded_file', file, fileName);
    }

    return axios.request({
      method: 'POST',
      url: `${url}/upload/${id}/${token}`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: function(progressEvent) {
        progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
      },
      data: formData
    });
  };

  const computeIcon = item => {
    if (item.mIcon) {
      return getImageById(item.mIcon);
    }

    if (item.mPicture) {
      return getImageById(item.mPicture);
    }

    return null;
  };

  const isImage = mediaType => {
    if (!mediaType) {
      return false;
    }
    return mediaType.includes('image');
  };

  const downloadMediaAsFile = id => {
    return axios.get(getImageById(id));
  };
  return {
    getImageById,
    computeIcon,
    uploadMedia,
    downloadMediaAsFile,
    isImage
  };
};
export default useMedia;
